import React, { ReactElement, PropsWithChildren } from 'react';

export type CardFooterProps = PropsWithChildren<{
  className?: string;
}>;

export function CardFooter({
  className,
  children,
}: CardFooterProps): ReactElement {
  return (
    <div className={className} aria-label="Card footer">
      {children}
    </div>
  );
}
